import React from "react";
import {useUserContext} from "../../contexts/user-context";
import {Select} from "./Select";
import {SelectId} from "./SelectId";

export const BookingTypeSelect = (props) => {
    const bookingTypeOptions = [
        { id: 'Pencil', label: 'Pencil' },
        //  {id:'Paid',label:'Paid'},
        { id: 'Booked', label: 'Booked' },
    ];
    const user = useUserContext();
    if(user.hasPermission('panelbookings.campaign_panel_booking_free')) {
        bookingTypeOptions.push({ id: 'Free', label: 'Free' });
    }
    return props.valueIsId?
        <SelectId options={bookingTypeOptions} defaultOption={bookingTypeOptions[0]} {...props}  labelField="label" />:
        <Select options={bookingTypeOptions} defaultOption={bookingTypeOptions[0]} {...props}  labelField="label" />
}
